export class Config {
  constructor(props) {
    this.version = '';
    this.envName = '';
    this.theme = '';
    this.apiBaseUrl = '';
    this.apiKeyManagerUrl = '';
    this.apiBillingUrl = '';
    this.apiResellerUrl = '';
    this.apiAuthUrl = '';
    this.apiTelemetryUrl = '';
    this.apiMonitoringUrl = '';
    this.apiAutoScalingUrl = '';
    this.gaIsTracking = '';
    this.gaTrackingId = '';
    this.settings = {
      support: {
        phone: null,
        email: null,
        emailSubject: null,
        emailBody: null,
      },
      copyright: null,
      s3Endpoint: null,
    };

    this.features = {
      tableViewSwitch: null,
      networkLoadBalancer: null,
      formDialog: null,
    };

    if (props) {
      Object.assign(this, props);
    }
  }
}
